import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Provider, connect } from "react-redux";
import { Router } from 'react-router-dom';
import history from './history';
import { MainRoutes } from './routes/routes';
import store from './store'
import { store as stores } from "./testStore";
import { safeDeepGetWithType } from 'iotera-base/json';

import reduxDialog from "redux-dialog";
import Notifications from 'react-notification-system-redux';
// import main style dependency file
import './index.scss';
import './scss/style.scss'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { SnackbarProvider, withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: {
            main: '#4D2C91'
        },
        secondary: {
            main: '#fff',
        },
        grey: {
            "100": '#7E57C2'
        }
    },
    overrides: {
        MuiTabs: {
            root: {
                backgroundColor: '#ffffff'
            }
        },
        MuiListItemIcon: {
            root: {
                color: '#000',
                marginRight: 8
            },

        },
        MuiTooltip: {
            tooltipPlacementBottom: {
                margin: '4px 0'
            },
            tooltipPlacementRight: {
                margin: '0 4px'
            },
            tooltipPlacementLeft: {
                margin: '0 4px'
            },
            tooltipPlacementTop: {
                margin: '4px 0'
            },
            tooltip: {
                backgroundColor: '#6F6F6F',
            }
        },
        // For Limit Height of Material Ui Select 
        MuiList: {
            root: {
                maxHeight: '368px'
            }
        },
        MuiStepper: {
            root: {
                display: 'flex',
                padding: 16
            }
        },
        MuiStepLabel: {

            label: {
                color: '#979CA4',
                "&.MuiStepLabel-active": {
                    color: '#F5F6F7',
                    fontWeight: 500
                },
                "&.MuiStepLabel-completed": {
                    color: '#F5F6F7',
                    fontWeight: 500
                },
                "&.MuiStepLabel-alternativeLabel": {
                    marginTop: 5,
                    textAlign: 'center'
                }
            }
        },

    }
}
)

const BasicDialog = ({ payload }) => <div style={{ minHeight: '50px', backgroundColor: '#f00' }}>{safeDeepGetWithType(payload, ['text'], 'My Awesome Dialog!')}</div>;

const Dialog = reduxDialog({
    name: "0"
})(BasicDialog);
class Base extends Component {

    handleClick = button => () => {
        // Avoid material-ui warnings. more info: https://material-ui.com/style/typography/#migration-to-typography-v2
        // eslint-disable-next-line no-underscore-dangle
        window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
        this.props.enqueueSnackbar(button.message, { variant: button.variant });
    };

    handleClickWithAction = () => {
        this.props.enqueueSnackbar('Customise this snackbar youself.', {
            variant: 'Warning',
            action: (
                <Button color="secondary" size="small" onClick={() => alert('clicked on my custom action')}>
                    Test
                </Button>
            ),
        });
    };

    render() {
        let notifs = safeDeepGetWithType(this, ['props', 'notifications'], []);
        let length = notifs.length;
        if (length > 0) {
            const action = (key) => (
                <Fragment>
                    <IconButton color="inherit" onClick={() => { this.props.closeSnackbar(key) }} aria-label="Close">
                        <CloseIcon style={{ height: 16, width: 16 }} />
                    </IconButton>
                </Fragment>
            );
            let notif = notifs[length - 1];
            let position = safeDeepGetWithType(notif, ['position'], 'tr');

            let positionV = position.substring(0, 1) === 't' ? 'top' : 'bottom';
            let h = position.substring(position.length - 1, position.length);
            let positionH = 'right'
            if (h === 'l') {
                positionH = 'left'
            } else if (h === 'c') {
                if (positionV === 'top') {
                    positionH = 'middle'
                } else {
                    positionH = 'center'
                }
            }
            this.props.enqueueSnackbar(
                notif.message,
                {
                    action,
                    variant: notif.level,
                    anchorOrigin: {
                        vertical: positionV,
                        horizontal: positionH,
                    }
                }
            );
        }

        return (
            <div>
                <div style={{ visibility: 'hidden' }}>
                    <Notifications notifications={this.props.notifications} />
                </div>
                <Dialog
                    appElement={document.getElementById('root')}
                />
                <Router history={history}>
                        <MainRoutes />
                </Router>
            </div >
        )
    }
}

const mapStateToProps = function (state) {
    return {
        notifications: state.notifications
    }
};

const BaseC = connect(mapStateToProps)(withSnackbar(Base));

function getUrlVars() {
    let vars = [], hash;
    let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

let urlParams = getUrlVars();

let render = undefined;

const StyledSnackbar = withStyles({
    'variantSuccess': {
        background: 'linear-gradient(to left top, #a5d6a7, #4caf50)'
    },
    'variantError': {
        background: 'linear-gradient(to left top, #ef9a9a, #f44336)'
    },
    'variantWarning': {
        background: 'linear-gradient(to left top, #ffcc80, #ff9800)'
    },
    'variantInfo': {
        background: 'linear-gradient(to left top, #80deea, #00bcd4)'
    },
})(SnackbarProvider);

render = () => {
    ReactDOM.render(
        <Provider store={store}>
            <MuiThemeProvider theme={theme}>
                <StyledSnackbar
                    maxSnack={3}
                    preventDuplicate={true}
                // autoHideDuration={2000}
                >
                    <BaseC />
                </StyledSnackbar>
            </MuiThemeProvider>
        </Provider>, document.getElementById('root')
    )
}
stores.subscribe(render);

render();